const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/custom-fields/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { getCustomFieldsQueryOptions } from '@/lib/queries/common/useGetCustomFieldsQuery';
import i18n from '@/lib/translations/i18n';
import type { LoaderData } from '@/lib/types/common';
export const Route = createFileRoute('/(app)/org/$org/settings/custom-fields/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    await queryClient.ensureQueryData(getCustomFieldsQueryOptions());
    return {
      crumb: i18n.t('common.settings.customFields.customFields')
    };
  },
  staticData: {
    topNav: {
      title: i18n.t('common.settings.customFields.customFields')
    }
  }
});